export default __webpack_public_path__ + "static/media/assembled.7faec401.svg";